import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { INTEL_API, errMsg } from "./OutreachSendButton";

export const QuickCreate = ({ onCreated }) => {
  const [name, setName] = useState("");
  const [domain, setDomain] = useState("");
  const [orgId, setOrgId] = useState("");
  const [title, setTitle] = useState("");

  const createOrg = async () => {
    try {
      const r = await axios.post(`${INTEL_API}/organizations`, { canonical_name: name, official_domain: domain || null });
      setOrgId(r.data.id); setName(""); setDomain("");
      toast.success("Organisation créée"); onCreated();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const createOpp = async () => {
    try {
      await axios.post(`${INTEL_API}/opportunities`, { organization_id: orgId, title, opportunity_type: "PRESS_EVENT" });
      setTitle(""); toast.success("Opportunité créée"); onCreated();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="grid gap-3 md:grid-cols-2" data-testid="intel-quick-create">
      <div className="flex gap-2">
        <Input placeholder="Nom de l'organisation" value={name} onChange={(e) => setName(e.target.value)} data-testid="intel-org-name-input" />
        <Input placeholder="domaine.com" value={domain} onChange={(e) => setDomain(e.target.value)} data-testid="intel-org-domain-input" />
        <Button onClick={createOrg} disabled={!name} data-testid="intel-org-create-btn">Créer</Button>
      </div>
      <div className="flex gap-2">
        <Input placeholder="ID organisation" value={orgId} onChange={(e) => setOrgId(e.target.value)} data-testid="intel-opp-org-input" />
        <Input placeholder="Titre de l'opportunité" value={title} onChange={(e) => setTitle(e.target.value)} data-testid="intel-opp-title-input" />
        <Button onClick={createOpp} disabled={!orgId || !title} data-testid="intel-opp-create-btn">Ajouter</Button>
      </div>
    </div>
  );
};
